module.exports = __webpack_public_path__ + "img/aiot-pc.471294ca.svg";